import { render, staticRenderFns } from "./ExceptionEvents.vue?vue&type=template&id=d6d6ca40&"
import script from "./ExceptionEvents.vue?vue&type=script&lang=ts&"
export * from "./ExceptionEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports